<style lang="scss" scoped>
img {
  cursor: pointer;

  &:hover {
    box-shadow: 0 0 5px 4px #666;
  }
}
</style>

<template>
  <div class="card">
    <div v-if="working" class="card-body p">
      <div class="d-flex justify-content-around">
        <i class="fas fa-spinner fa-spin fa-10x"></i>
      </div>
    </div>
    <div v-else class="card-body p-0">
      <div class="d-flex flex-wrap">
        <div v-for="(image, index) in privateImages" :key="image.id">
          <div class="d-flex flex-column" v-if="!image.is_online">
            <img
              @click="
                $emit('send-private-image', image) &&
                  $modal.hide('private-images')
              "
              class="m-1"
              :key="index"
              :src="
                `/api/v1/customerMedia/${image.id}/display?height=200&width=200`
              "
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      working: false
    };
  },
  created() {
    this.queryPrivateImages();
  },
  methods: {
    queryPrivateImages() {}
  },
  computed: {
    currency() {
      return Laravel.lang.currency;
    },
    privateImages() {
      let media = this.$store.getters["moderation/fake"].media;
      return Array.isArray(media) ? media : [];
    }
  }
};
</script>
